import AuthError from './authError';

export default class TokenValidationError extends AuthError {}
